/**
 * Data-room UI helpers.
 *
 * The per-document viewer / last-viewed metric is now backed by REAL telemetry
 * (`data_room_events`) via `useDataRoomViewStats` in
 * `@/lib/dataroom/use-dataroom-views`. The former `computeDocumentActivity`
 * proxy (derived from dealflow access + shared-DD collaborators + latest DD
 * `updatedAt`) was removed in FR-P0-07 — it fabricated viewer counts. This
 * module now holds only the shared `timeAgo` formatter.
 */

/** Time-ago label, simple. */
export function timeAgo(iso?: string): string | undefined {
  if (!iso) return undefined;
  const ms = Date.now() - new Date(iso).getTime();
  if (ms < 0) return undefined;
  const min = Math.floor(ms / 60_000);
  if (min < 1) return 'just now';
  if (min < 60) return `${min}m ago`;
  const hr = Math.floor(min / 60);
  if (hr < 24) return `${hr}h ago`;
  const day = Math.floor(hr / 24);
  if (day < 30) return `${day}d ago`;
  const mo = Math.floor(day / 30);
  return `${mo}mo ago`;
}
